import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import ListSubheader from '@material-ui/core/ListSubheader';

import { getSelectedMenuItemTitle } from '../utils/permissions';
import { KeycloakContext } from '../components/Secured';
import AiRunsMenuBadge from '../components/product/BulkImport/components/AiRunsMenuBadge';

// The bulk import of a superuser or a producer: its icon tells of the AI imports not seen yet.
const BULK_IMPORT_LINK = /^\/(superuser\/)?bulk-import-new\//;

interface INavItem {
    link: string;
    title: string;
    component: any; // TODO any
    icon: any; // TODO any
    section?: string;
}

interface INavMenuProps {
    navItems?: INavItem[];
}

const NavMenu = ({ navItems }: INavMenuProps) => {
    const keycloakCtx = useContext(KeycloakContext);
    const isStore = keycloakCtx.keycloak.hasResourceRole('store');
    const isSuperuser = keycloakCtx.keycloak.hasResourceRole('superuser');

    // Get path info to be able to decide selected navigation menu.
    let location = useLocation();
    const selectedMenuItemTitle = getSelectedMenuItemTitle(location?.pathname || '', isStore, isSuperuser);
    
    return (
      <>
        <List>
            {Array.isArray(navItems) && navItems.length ? (
                navItems.map((item, index) => {
                    // Items of a group are listed together; the heading goes above the first one.
                    const startsSection = !!item.section && item.section !== navItems[index - 1]?.section;
                    return (
                      <React.Fragment key={item.title}>
                        {startsSection && <ListSubheader disableSticky>{item.section}</ListSubheader>}
                        <ListItem
                            button
                            component={Link}
                            to={item.link}
                            selected={selectedMenuItemTitle === item.title}
                        >
                            <ListItemIcon>
                                {BULK_IMPORT_LINK.test(item.link) ? (
                                    <AiRunsMenuBadge>{React.createElement(item.icon)}</AiRunsMenuBadge>
                                ) : (
                                    React.createElement(item.icon)
                                )}
                            </ListItemIcon>
                            <ListItemText primary={item.title} style={{ whiteSpace: 'pre-wrap' }} />
                        </ListItem>
                      </React.Fragment>
                    );
                })
            ) : (
                <span>No menu found</span>
            )}
        </List>
      </>
    );
};

export default NavMenu;
